import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting home banners
export const getAllProducts = createAsyncThunk(
  "all-products",
  async (
    {
      page = 1,
      per_page = 8,
      category_id = "",
      sub_category_id = "",
      sub_category = "",
      childcategory_id,
      brand_id = "",
      need_id,
      colour_id = "",
      polish_id = "",
      size_id = "",
      earring_style = "",
      necklace_style = "",
      occasion = "",
      design_shape = "",
      max_price = "",
      name = "",
      priceOrder,
      shape_id = "",
      sortBy = "",
      type = "",
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `?page=${page}&per_page=${per_page}&category_id=${category_id ||
            ""}&sub_category_id=${sub_category_id ||
            ""}&sub_category=${sub_category ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&colour_id=${colour_id ||
            ""}&polish_id=${polish_id || ""}
          &size_id=${size_id || ""}&need_id=${need_id ||
            ""}&earring_style=${earring_style || ""}
          &necklace_style=${necklace_style || ""}&occasion=${occasion ||
            ""}&design_shape=${design_shape || ""}
          &max_price=${max_price || ""}&type=${type || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}&sortBy=${sortBy ||
            ""}&shape_id=${shape_id || ""}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getOnlyProducts = createAsyncThunk(
  "only-products",
  async (
    {
      page = 1,
      per_page = 8,
      category_id = "",
      sub_category_id = "",
      childcategory_id = "",
      brand_id = "",
      need_id = "",
      colour_id = "",
      polish_id = "",
      size_id = "",
      earring_style = "",
      necklace_style = "",
      occasion = "",
      design_shape = "",
      max_price = "",
      name = "",
      priceOrder = "",
      shape_id = "",
      sortBy = "",
      type = "",
    },
    { rejectWithValue },
  ) => {
    try {
      const url =
        API.GET_ONLY_PRODUCTS +
        `/${type}` +
        `?page=${page}` +
        `&per_page=${per_page}` +
        `&category_id=${category_id}` +
        `&sub_category_id=${sub_category_id}` +
        `&child_category_id=${childcategory_id}` +
        `&brand_id=${brand_id}` +
        `&colour_id=${colour_id}` +
        `&polish_id=${polish_id}` +
        `&size_id=${size_id}` +
        `&need_id=${need_id}` +
        `&earring_style=${earring_style}` +
        `&necklace_style=${necklace_style}` +
        `&occasion=${occasion}` +
        `&design_shape=${design_shape}` +
        `&max_price=${max_price}` +
        `&type=${type}` +
        `&name=${name}` +
        `&priceOrder=${priceOrder}` +
        `&sortBy=${sortBy}` +
        `&shape_id=${shape_id}`;

      const Data = await GET(url);

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//get only products header our collection

export const getHeaderProducts = createAsyncThunk(
  "header-products",
  async (
    {
      category_id = "",
      sub_category_id = "",
      childcategory_id,
      brand_id = "",
      need_id,
      colour_id = "",
      polish_id = "",
      size_id = "",
      earring_style = "",
      necklace_style = "",
      occasion = "",
      design_shape = "",
      max_price = "",
      name = "",
      priceOrder,
      shape_id = "",
      sortBy = "",
      type = "",
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_HEADER_CATEGORIES +
          `/${type}` +
          `?category_id=${category_id ||
            ""}&sub_category_id=${sub_category_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&colour_id=${colour_id ||
            ""}&polish_id=${polish_id || ""}
          &size_id=${size_id || ""}&need_id=${need_id ||
            ""}&earring_style=${earring_style || ""}
          &necklace_style=${necklace_style || ""}&occasion=${occasion ||
            ""}&design_shape=${design_shape || ""}
          &max_price=${max_price || ""}&type=${type || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}&sortBy=${sortBy ||
            ""}&shape_id=${shape_id || ""}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const searchProducts = createAsyncThunk(
  "search-products",
  async ({ name = "" }, { rejectWithValue }) => {
    try {
      const Data = await GET(
        API.GET_SEARCH_PRODUCTS + `?name=${encodeURIComponent(name)}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllTimeFavsProducts = createAsyncThunk(
  "all-products-material",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
      shape_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_TIME_PRODUCTS +
          `/${type}` +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}&shape_id=${shape_id || ""}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllProductsHARVESTED = createAsyncThunk(
  "all-products-shape",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `/${type}` +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );

      return Data?.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllProductsNewLaunch = createAsyncThunk(
  "all-products-newlaunch",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `/${type}` +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );

      return Data?.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllOURProduct = createAsyncThunk(
  "all-products-populer",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_OUR_PRODUCTS +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getProduct = createAsyncThunk(
  "product",
  async (id, { rejectWithValue }) => {
    try {
      const data = await GET(API.GET_PRODUCT + `/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getCommonVariant = createAsyncThunk(
  "product-variant",
  async (id, { rejectWithValue }) => {
    try {
      const data = await GET(API.GET_PRODUCT + `/variant/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getSizeVariant = createAsyncThunk(
  "product-variant-size",
  async ({ id, metal_id, diamond_id }, { rejectWithValue }) => {
    try {
      const data = await GET(
        API.GET_PRODUCT +
          `/size-variant/${id}?metal_id=${metal_id}&diamond_id=${diamond_id}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getLinkedProduct = createAsyncThunk(
  "linked-product",
  async (id, { rejectWithValue }) => {
    try {
      const data = await GET(API.GET_LINKED_PRODUCT + `/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getGroupByProduct = createAsyncThunk(
  "group-by-product",
  async ({ p_category_id }, { rejectWithValue }) => {
    try {
      const data = await GET(
        API.GET_ALL_PRODUCT_GROUP_BY_SUB_CATEGORIES +
          `?p_category_id=${p_category_id || ""}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const findCombination = createAsyncThunk(
  "auth/product-combination",
  async (data, { rejectWithValue }) => {
    try {
      const combinationdata = await POST(
        API.GET_PRODUCT + `/combination`,
        data,
      );

      return combinationdata;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const pincodeCheck = createAsyncThunk(
  "auth/product-pincode",
  async (data, { rejectWithValue }) => {
    try {
      const combinationdata = await POST(
        API.GET_PRODUCT + `/${data?.product_id}`,
        data,
      );

      return combinationdata;
    } catch (error) {
      console.log("catch value");

      return rejectWithValue(error.message);
    }
  },
);

// Thunk for getting Add banners

// Thunk for getting Add banners
export const getspecialitystatus = createAsyncThunk(
  "product/add-specialstatus",
  async (_, { rejectWithValue }) => {
    try {
      const specialstatusData = await GET(API.GET_SPECIAL_STATUS);
      return specialstatusData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllProductsDetails = createAsyncThunk(
  "all-products-detail",
  async (
    {
      page = 1,
      per_page = 8,
      category_id = "",
      sub_category_id = "",
      sub_category = "",
      childcategory_id,
      brand_id = "",
      need_id,
      colour_id = "",
      polish_id = "",
      size_id = "",
      earring_style = "",
      necklace_style = "",
      occasion = "",
      design_shape = "",
      max_price = "",
      name = "",
      priceOrder,
      shape_id = "",
      sortBy = "",
      type = "",
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `?page=${page}&per_page=${per_page}&category_id=${category_id ||
            ""}&sub_category_id=${sub_category_id ||
            ""}&sub_category=${sub_category ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&colour_id=${colour_id ||
            ""}&polish_id=${polish_id || ""}
          &size_id=${size_id || ""}&need_id=${need_id ||
            ""}&earring_style=${earring_style || ""}
          &necklace_style=${necklace_style || ""}&occasion=${occasion ||
            ""}&design_shape=${design_shape || ""}
          &max_price=${max_price || ""}&type=${type || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}&sortBy=${sortBy ||
            ""}&shape_id=${shape_id || ""}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const handleAsyncState = (state, action, isSignin = false) => {
  switch (action.type) {
    case "pending":
      state.status = "loading";
      break;
    case "fulfilled":
      state.status = "succeeded";
      if (isSignin) {
        state.token = action.payload;
        state.is_signin = true;
      }
      break;
    case "rejected":
      state.status = "failed";
      state.error = action.payload;
      if (isSignin) state.is_signin = false;
      break;
    default:
      return state;
  }
};
// Create the slice
const productSlice = createSlice({
  name: "product",
  initialState: {
    allProducts: [],
    allProductsDetails: [],
    total_pages: "",
    total_pages_detail: "",
    currentPage: 1,
    currentPage_detail: 1,
    loading: true,

    onlyProducts: [],
    headProducts: [],
    searchProducts: [],
    allProductsGroup: [],
    allProductsFavs: [],
    allProductsSHARED: [],
    allProductsNewLaunch: [],
    allOurProducts: [],
    product: {},

    product_variant: {},
    variant_size: [],
    linked_products: [],
    addSpecialstatus: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducts.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        // console.log("State after pending.....", state);
      })

      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;

        console.log(action.meta.arg, "action.meta.arg action.meta.arg");

        if (action.meta.arg.page === 1) {
          // Replace products
          state.allProducts = action.payload.data || [];
        } else {
          // Append products for infinite scroll
          state.allProducts = [
            ...state.allProducts,
            ...(action.payload.data || []),
          ];
        }
        console.log(state.allProducts, "allProducts allProducts");

        state.total_pages = action.payload.total_pages;
        state.currentPage = action.payload.current_page;
      })

      .addCase(getAllProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = true;
        // console.log("State after rejected.....", state);
      })

      .addCase(getAllProductsDetails.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        // console.log("State after pending.....", state);
      })

      .addCase(getAllProductsDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;

        const hasSubCategory = Boolean(action.meta.arg?.sub_category);

        if (action.meta.arg.page === 1) {
          // Replace products
          state.allProductsDetails = action.payload.data || [];
        } else {
          // Append products for infinite scroll
          state.allProductsDetails = [
            ...state.allProductsDetails,
            ...(action.payload.data || []),
          ];
        }

        state.total_pages_detail = action.payload.total_pages;
        state.currentPage_detail = action.payload.current_page;
      })

      .addCase(getAllProductsDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = true;
        // console.log("State after rejected.....", state);
      })

      //only products
      .addCase(getOnlyProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOnlyProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.onlyProducts = action.payload || {};
      })
      .addCase(getOnlyProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      //only products
      .addCase(getHeaderProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHeaderProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.headProducts = action.payload || {};
      })
      .addCase(getHeaderProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(searchProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(searchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.searchProducts = action.payload || {};
      })
      .addCase(searchProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllTimeFavsProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllTimeFavsProducts.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.allProductsFavs = action.payload || [];
      })
      .addCase(getAllTimeFavsProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllProductsHARVESTED.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllProductsHARVESTED.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.allProductsSHARED = action.payload || [];
      })
      .addCase(getAllProductsHARVESTED.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getAllProductsNewLaunch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllProductsNewLaunch.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.allProductsNewLaunch = action.payload || [];
      })
      .addCase(getAllProductsNewLaunch.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllOURProduct.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllOURProduct.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.allOurProducts = action.payload || [];
      })
      .addCase(getAllOURProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getProduct.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.product = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getSizeVariant.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getSizeVariant.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.variant_size = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getSizeVariant.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getCommonVariant.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getCommonVariant.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.product_variant = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getCommonVariant.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getLinkedProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getLinkedProduct.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.linked_products = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getLinkedProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getGroupByProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getGroupByProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allProductsGroup = action.payload || [];
      })
      .addCase(getGroupByProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(findCombination.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true),
      )
      .addCase(findCombination.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true,
        ),
      )
      .addCase(findCombination.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true,
        ),
      )
      .addCase(pincodeCheck.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true),
      )
      .addCase(pincodeCheck.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true,
        ),
      )
      .addCase(pincodeCheck.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true,
        ),
      )

      .addCase(getspecialitystatus.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getspecialitystatus.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.addSpecialstatus = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getspecialitystatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      });
  },
});

export default productSlice.reducer;
